import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { NSchange, parseClasses, generateUUID } from '../../lib/ep.js';

import { SquaredButton } from './ActionButton';
import FieldErrorMessage from './FieldErrorMessage';
import FieldLabel from './FieldLabel';

import Rating from '../custom_components/rating/RatingAPILayer';

const RatingField = (props) => {
	const element_id = generateUUID();
	const v = props?.value ?? ((props.model != undefined) ? NSchange(props.model, props.name) : '');

	const [ value, setValue ] = useState(v);

	useEffect(() => {
		scaleToFit();
		window.addEventListener('resize', scaleToFit);

		return () => {
			window.removeEventListener('resize', scaleToFit);
		};
	}, []);

	useEffect(() => {
		scaleToFit(true);
	}, [ props ]);

	const scaleToFit = (pre_reset_scale = false) => {
		var container = document.getElementById(`${element_id}_container`);

		if(container == undefined) {
			setTimeout(() => {
				scaleToFit(pre_reset_scale);
			}, 100);
			return;
		}

		if(pre_reset_scale) container.style.transform = 'scale(1)';

		const container_width = container.offsetWidth;
		const this_rating_width = container.getElementsByClassName('this_rating')[0].offsetWidth;
		const reset_width = container.getElementsByClassName('reset_rating')[0].offsetWidth;

		container.style.transform = `scale(${Math.min((container_width / (this_rating_width + reset_width)), 1)})`;
	};

	//When the input change reflect the change
	const change = (e) => {
		//Call the passed callback
		if(props.change != undefined) {
			let res = props.change(props.name, e);
			if(res === false) return;
		}

		setValue(e);
	};

	const resetRating = (e) => {
		change(0);
	};

	const has_error = (props.errors && props.errors[props.name]) ? props.errors[props.name] : false;

	const star_count = props?.star_count ?? 5;
	const default_rate = props?.default_rate ?? Math.round(star_count / 2);

	const _field_styles = props?._field_style ?? {};

	const icon_off = props?.icon_off ?? 'knk-star-off';
	const icon_on = props?.icon_on ?? 'knk-star-on';
	const icon_reset = props?.icon_reset ?? 'knk-off';
	const icon_reset_color = props?.icon_reset_color ?? 'red';
	const disabled = props?.disabled ?? false;

	let classname = props?.classname ?? 'input rating';
	classname = parseClasses(classname, props._class, 'rating');

	const item_classes = ['react_field'];
	if(props._field_class != undefined) {
		item_classes.push(props._field_class);
	}

	const field_classes = [classname];
	if(disabled) field_classes.push('disabledField');
	if(has_error) field_classes.push('has_error');

	return (
		<div class={item_classes.join(" ")} style={_field_styles}>
			<div class={field_classes.join(" ")}>
				<FieldLabel
					{...props.label_props}
					name={props.name}
					autotranslate={props.autotranslate}
				>{props.children}</FieldLabel>

				<div id={`${element_id}_container`} class="gui_rating_container">
					<SquaredButton
						color={false}
						icon={icon_reset}
						_class={{ other:`${icon_reset_color}Icon reset_rating`, submit:false }}
						onClick={resetRating}
						aria-label="Reset rating"
					/>

					<Rating
						className="this_rating"
						initialRating={(value === "") ? default_rate : value}
						stop={star_count}
						emptySymbol={<span className={`icon ${icon_off}`} />}
						fullSymbol={`icon ${icon_on}`}
						onChange={change}
					/>
				</div>

				{(has_error) && (
					<FieldErrorMessage>{has_error}</FieldErrorMessage>
				)}
			</div>
		</div>
	);
};

export default injectIntl(RatingField);